import { render, staticRenderFns } from "./jak-kupic-akcje-nvidia.md?vue&type=template&id=6a0e08e1&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports